import React from 'react';

import { allState } from './data';

import {
  Container,
  Step,
  StepLine,
  StepIcon,
  StepText,
} from './styles';

function Stepper({
  stepCurrent = 0,
  steps = [],
}) {
  const getStatusToStep = (atual, index) => (
    index === atual
      ? allState.active.status
      : index < atual
        ? allState.prev.status
        : allState.next.status
  );

  return (
    <Container>
      {
        steps.map((step, indexStep) => {
          const statusStep = getStatusToStep(stepCurrent, indexStep);
          return (
            <Step status={statusStep} key={step} className="step">
              <StepLine last={indexStep === steps.length - 1} status={statusStep} />
              <StepIcon color={allState[statusStep].color}>
                { allState[statusStep].icon && (
                  <img src={allState[statusStep].icon} alt="" />
                )}
              </StepIcon>
              <StepText>{step}</StepText>
            </Step>
          );
        })
      }
    </Container>
  );
}

export default Stepper;
